import moment from "moment";
import { handednessObj, triggerTypeObj } from "./constants";

export function getActiveRouteData({ pathname, activeSportType }: any) {
  let token, url;
  let isLaunch = false;
  let isGolf = false;
  let isAthletics = false;
  let isSimulation = false;
  let isUserHistory = false;
  let origin = "unknown";
  switch (pathname) {
    case "/m2c-golf-history":
      url = "/get_full_history";
      // url = "/get_pagination_history";
      token = "331212";
      origin = "m2c";
      isGolf = true;
      break;
    case "/pg-history":
      url = "/get_full_history";
      // url = "/get_pagination_history";
      token = "331212";
      origin = "m2c";
      isGolf = true;
      break;
    case "/m2c-launch-history":
      url = "/get_full_history_launch";
      token = "331213";
      origin = "launch";
      isLaunch = true;
      break;
    case "/m2c-athletics-history":
      url = "/athletics_history";
      origin = "athletics";
      token = "331214";
      isAthletics = true;
      break;

    case "/simulation-history":
      url = "/get_simulation_videos";
      origin = "simulation";
      token = "331215";
      isSimulation = false;
      break;
    case "/tonal-history":
      url = "/get_simulation_videos";
      origin = "simulation";
      token = "331215";
      isSimulation = true;
      break;
    case "/user-history":
      url = endPointBasedOnSport(activeSportType);
      origin = "user-history";
      token = null;
      isUserHistory = true;
      break;
    default:
      url = "/get_pagination_history";
      origin = "m2c";
      token = "331212";
      break;
  }

  return {
    url,
    token,
    isGolf,
    isLaunch,
    isAthletics,
    isSimulation,
    origin,
    isUserHistory,
  };
}

function endPointBasedOnSport(selectedSport: any) {
  switch (selectedSport) {
    case "golf":
      return "/user_golf_video";
    case "baseball":
      return "/user_baseball_video";
    case "athletics":
      return "/user_athletics_video";

    default:
      break;
  }
}
export interface DataItem {
  name: string;
  value: any;
}

export function transformHistoryDataToDataSource(historyData: {
  message: any;
  videos: any[];
}): any {
  if (historyData.message) {
    return;
  }

  if (!Array.isArray(historyData?.videos)) {
    return [];
  }
  // Sort by date and time, with year-based ordering first
  const videosArray = historyData?.videos?.sort((a, b) => {
    const dateA = new Date(a.upload_time || "");
    const dateB = new Date(b.upload_time || "");

    // Order by year first (descending order)
    if (dateA.getFullYear() !== dateB.getFullYear()) {
      return dateB.getFullYear() - dateA.getFullYear();
    }

    // Then by month, day, and time (descending order)
    return dateB.getTime() - dateA.getTime();
  });
  const formatOrientation = (orientation: string): string => {
    // Capitalize the first letter of each word and replace "DownTheLine" with "Down the Line"
    return orientation
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formatSwingType = (swingType: string): string => {
    // Capitalize the first letter of each word and handle specific cases
    const swingTypeExceptions: any = {
      "full swing": "Full Swing",
      "short game": "Short Game",
      putter: "Putter",
      bunker: "Bunker",
      scan: "Scan",
      // Add more exceptions here as needed
    };
    return (
      swingTypeExceptions[swingType.toLowerCase()] ||
      swingType?.replace(/\b\w/g, (c) => c.toUpperCase())
    );
  };

  const formatClubType = (clubType: string): string => {
    // Capitalize the first letter of each word
    return clubType?.replace(/\b\w/g, (c) => c.toUpperCase());
  };

  function formatVideoName(url: string): string {
    // Extract video name from URL
    const parts = url?.split("/");
    const lastSegment = parts[parts?.length - 1];
    return lastSegment;
  }

  const getEmailAndVideoNameFromUrl = (url: string) => {
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[parts.length - 2];
    // Get the last part of the URL
    const lastPart = parts[parts.length - 1];
    // Remove the ".mp4" extension if it exists
    const videoName = lastPart?.replace(".mp4", "");
    // Return an object containing the email and video name

    return generateVideoName(email, videoName);
  };

  const getEmail = (url: string) => {
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[parts.length - 2];
    // Get the last part of the URL

    // Return an object containing the email and video name

    return email;
  };

  function formatDeviceType(url: string): string {
    // Extract device type from URL
    if (url.includes("m2c-and")) {
      return "Android";
    } else if (url.includes("m2c-iOS")) {
      return "IOS";
    } else if (url.includes("dc1")) {
      return "Desktop";
    } else {
      return "--";
    }
  }

  function cameraMovedDto(isCameraMoved: any) {
    if (isCameraMoved === "true") {
      return "Yes";
    } else if (isCameraMoved === "false") {
      return "No";
    }

    return "-";
  }

  return videosArray?.map((video, index) => ({
    key: index.toString(),
    dateTime: moment(video.upload_time).format("YYYY-MM-DD HH:mm:ss") || "",
    queue_id: video?.queue_id,
    videoName: formatVideoName(video?.queue_id) || `Video ${index + 1}`,
    userRole: video?.user_role || "--",
    deviceType: formatDeviceType(video.queue_id) || "--",
    clubType: formatClubType(video.clubType || "--"),
    swingType:
      video?.purpose === "Scan"
        ? video?.purpose
        : formatSwingType(video.swingType || "--"),
    orientation: formatOrientation(video.orientation || "--"),
    fileId: getEmailAndVideoNameFromUrl(video.queue_id),
    uploader: getEmail(video.queue_id),
    poseServer: video?.processed_by || "--",
    clubServer: video?.server_name_club || "--",
    clubStatus:
      video?.purpose === "Scan" ? "Not Required" : video?.status_club || "--",
    handedness: handednessObj[video.handedness],

    poseStatus:
      video?.current_status !== undefined
        ? video?.current_status
        : "--" || "--",
    totalProcessing:
      video?.total_processing !== undefined && video?.total_processing !== null
        ? video?.total_processing + "s"
        : "--" || "--",
    trigger: triggerTypeObj[video?.trigger_type] || "-",
    isCameraMoved: cameraMovedDto(video?.isCameraMoved),
    deviceAngle: video?.camera_orientation || "-",
    iso: video?.iso || "-",
    shutter: Number(video?.shutter) || "-",
    duration: Number(video?.duration) || "-",
    frameRate: Number(video?.frame_rate) || "-",
    camera: video?.camera_type || "Back",
    resolution: video?.resolution || "-",
    recordingType: video?.recordingType || "-",
  }));
}

export function transformHistoryDataToDataSourceLaunch(historyData: {
  message: any;
  videos: any[];
}): any {
  if (historyData.message) {
    return;
  }

  if (!Array.isArray(historyData?.videos)) {
    return [];
  }
  // Sort by date and time, with year-based ordering first
  const videosArray = historyData?.videos?.sort((a: any, b: any) => {
    const dateA = new Date(a.upload_time || "");
    const dateB = new Date(b.upload_time || "");

    // Order by year first (descending order)
    if (dateA.getFullYear() !== dateB.getFullYear()) {
      return dateB.getFullYear() - dateA.getFullYear();
    }

    // Then by month, day, and time (descending order)
    return dateB.getTime() - dateA.getTime();
  });
  const formatOrientation = (orientation: string): string => {
    // Capitalize the first letter of each word and replace "DownTheLine" with "Down the Line"
    return orientation
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formatSwingType = (swingType: string): string => {
    // Capitalize the first letter of each word and handle specific cases
    const swingTypeExceptions: any = {
      "full swing": "Full Swing",
      "short game": "Short Game",
      putter: "Putting",
      bunker: "Bunker",
      // Add more exceptions here as needed
    };
    return (
      swingTypeExceptions[swingType.toLowerCase()] ||
      swingType.replace(/\b\w/g, (c) => c.toUpperCase())
    );
  };

  const formatClubType = (clubType: string): string => {
    // Capitalize the first letter of each word
    return clubType.replace(/\b\w/g, (c) => c.toUpperCase());
  };

  function formatVideoName(url: string): string {
    // Extract video name from URL
    const parts = url.split("/");
    const lastSegment = parts[parts.length - 1];
    return lastSegment;
  }

  const getEmailAndVideoNameFromUrl = (url: string) => {
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[parts.length - 2];
    // Get the last part of the URL
    const lastPart = parts[parts.length - 1];
    // Remove the ".mp4" extension if it exists
    const videoName = lastPart.replace(".mp4", "");
    // Return an object containing the email and video name

    return generateVideoName(email, videoName);
  };

  const getEmail = (url: string) => {
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[parts.length - 2];
    // Get the last part of the URL

    // Return an object containing the email and video name

    return email;
  };

  function formatDeviceType(url: string): string {
    // Extract device type from URL
    if (url.includes("m2c-and")) {
      return "Android";
    } else if (url.includes("m2c-iOS")) {
      return "IOS";
    } else if (url.includes("dc1")) {
      return "Desktop";
    } else {
      return "--";
    }
  }

  function cameraMovedDto(isCameraMoved: any) {
    if (isCameraMoved === "true") {
      return "Yes";
    } else if (isCameraMoved === "false") {
      return "No";
    }

    return "-";
  }

  return videosArray?.map((video, index) => ({
    key: index.toString(),
    dateTime: moment(video.upload_time).format("YYYY-MM-DD HH:mm:ss") || "",
    videoName: formatVideoName(video.queue_id) || `Video ${index + 1}`,
    clubType: formatClubType(video.clubType || "--"),
    swingType: formatSwingType(video.swingType || "--"),
    orientation: formatOrientation(video.orientation || "--"),
    fileId: getEmailAndVideoNameFromUrl(video.queue_id),
    uploader: getEmail(video.queue_id),
    deviceType: formatDeviceType(video.queue_id) || "--",
    clubServer: video?.processed_by || "--",
    clubStatus: video?.current_status || "--",
    userRole: video?.user_role || "--",
    handedness: handednessObj[video.handedness],
    launchDataStatus:
      video?.launch_data_status === "Available" ? "done" : "error" || "--",
    totalProcessing:
      video?.total_processing !== undefined && video?.total_processing !== null
        ? video?.total_processing + "s"
        : "--" || "--",
    camera: video?.camera_type || "Back",
    trigger: triggerTypeObj[video?.trigger_type] || "-",
    deviceAngle: video?.camera_orientation || "-",
    isCameraMoved: cameraMovedDto(video?.isCameraMoved),
    iso: video?.iso || "-",
    shutter: Number(video?.shutter) || "-",
    duration: Number(video?.duration) || "-",
    frameRate: Number(video?.frame_rate) || "-",
  }));
}

export function transformHistoryDataToDataSourceAthletics(historyData: {
  message: any;
  videos: any[];
}): any {
  if (historyData.message) {
    return;
  }

  if (!Array.isArray(historyData?.videos)) {
    return [];
  }

  // Sort by date and time, with year-based ordering first
  const videosArray = historyData?.videos?.sort((a: any, b: any) => {
    const dateA = new Date(a.upload_time || "");
    const dateB = new Date(b.upload_time || "");

    // Order by year first (descending order)
    if (dateA.getFullYear() !== dateB.getFullYear()) {
      return dateB.getFullYear() - dateA.getFullYear();
    }

    // Then by month, day, and time (descending order)
    return dateB.getTime() - dateA.getTime();
  });
  const formatOrientation = (orientation: string): string => {
    // Capitalize the first letter of each word and replace "DownTheLine" with "Down the Line"
    return orientation
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formatSwingType = (swingType: string): string => {
    // Capitalize the first letter of each word and handle specific cases
    const swingTypeExceptions: any = {
      "full swing": "Full Swing",
      "short game": "Short Game",
      putter: "Putting",
      bunker: "Bunker",
      // Add more exceptions here as needed
    };
    return (
      swingTypeExceptions[swingType.toLowerCase()] ||
      swingType.replace(/\b\w/g, (c) => c.toUpperCase())
    );
  };

  const formatClubType = (clubType: string): string => {
    // Capitalize the first letter of each word
    return clubType.replace(/\b\w/g, (c) => c.toUpperCase());
  };

  function formatVideoName(url: string): string {
    // Extract video name from URL
    const parts = url.split("/");
    const lastSegment = parts[parts.length - 1];
    return lastSegment;
  }

  const getEmailAndVideoNameFromUrl = (url: string) => {
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[parts.length - 2];
    // Get the last part of the URL
    const lastPart = parts[parts.length - 1];
    // Remove the ".mp4" extension if it exists
    const videoName = lastPart.replace(".mp4", "");
    // Return an object containing the email and video name

    return generateVideoName(email, videoName);
  };

  const getEmail = (url: string) => {
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[parts.length - 2];
    // Get the last part of the URL

    // Return an object containing the email and video name

    return email;
  };

  function formatDeviceType(url: string): string {
    // Extract device type from URL
    if (url.includes("m2c-and")) {
      return "Android";
    } else if (url.includes("m2c-iOS")) {
      return "IOS";
    } else if (url.includes("dc1")) {
      return "Desktop";
    } else {
      return "--";
    }
  }

  return videosArray?.map((video, index) => ({
    key: index.toString(),
    dateTime: video.upload_time || "",
    videoName: formatVideoName(video.queue_id) || `Video ${index + 1}`,
    orientation: formatOrientation(video.orientation || "--"),
    fileId: getEmailAndVideoNameFromUrl(video.queue_id),
    uploader: getEmail(video.queue_id),
    deviceType: formatDeviceType(video.queue_id) || "--",
    poseStatus: video?.current_status || "--",
    poseServer: video?.processed_by || "--",
    userRole: video?.user_role || "Undefinded",
    totalProcessing:
      video?.total_processing !== undefined || video?.total_processing !== null
        ? video?.total_processing + "s"
        : "--",
  }));
}

export function transformHistoryDataToDataSourceSimulation(historyData: any) {
  if (!historyData) {
    return [];
  }

  function formatVideoName(url: string): string {
    // Extract video name from URL
    const parts = url.split("/");
    const lastSegment = parts[parts.length - 1];
    return lastSegment;
  }

  const getEmail = (url: string, userEmail: any) => {
    if (userEmail) {
      return userEmail;
    }
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[0];
    // Get the last part of the URL

    // Return an object containing the email and video name

    return email.includes("@") ? email : "--";
  };

  function getDeviceType(deviceType: any) {
    if (deviceType?.toLowerCase() === "ios") {
      return deviceType.toUpperCase();
    }
    return deviceType;
  }

  function getDateTime(uploadedTime: any) {
    if (uploadedTime?.includes(".")) {
      return uploadedTime?.split(".")[0];
    }

    return uploadedTime;
  }

  function formatUserOrientation(orientation: any) {
    if (!orientation) {
      return "--";
    }
    if (orientation?.toLowerCase() === "faceon") {
      return "Face On";
    }

    return "Down The Line";
  }

  function formatMovementType(movementType: any) {
    if (!movementType) return "--";
    return movementType?.slice(0, 1).toUpperCase() + movementType?.slice(1);
  }

  function cameraMovedDto(isCameraMoved: any) {
    if (isCameraMoved === "true" || isCameraMoved === "True") {
      return "Yes";
    } else if (isCameraMoved === "false" || isCameraMoved === "False") {
      return "No";
    }

    return "-";
  }

  function formatDeviceOrientation(deviceOrientation: any) {
    if (!deviceOrientation) {
      return "--";
    }
    return (
      deviceOrientation?.slice(0, 1).toUpperCase() + deviceOrientation?.slice(1)
    );
  }

  function formatDeviceCamera(deviceCamera: any) {
    if (!deviceCamera) {
      return "--";
    }

    return deviceCamera.slice(0, 1).toUpperCase() + deviceCamera.slice(1);
  }

  return Array.isArray(historyData)
    ? historyData?.map((video: any, index: any) => ({
        queue_id: video.queue_id,
        fileId: video.filename,
        videoName: formatVideoName(video.queue_id) || `Video ${index + 1}`,
        handedness: handednessObj[video.handedness] || "--",
        uploader: getEmail(video?.queue_id, video?.email),
        sportName:
          video?.sportName?.slice(0, 1).toUpperCase() +
            video?.sportName?.slice(1) || "--",
        movementType: formatMovementType(video?.hitType) || "--",
        deviceType: getDeviceType(video?.deviceType) || "--",
        orientation: formatUserOrientation(video?.orientation) || "",
        dateTime: getDateTime(video.uploaded_at) || "",

        processingStatus:
          video?.current_status !== undefined
            ? video?.current_status
            : "--" || "--",
        totalProcessing: video?.processingTime || "--",
        userRole:
          video?.role?.slice(0, 1).toUpperCase() + video?.role?.slice(1) ||
          "--",
        modelType: video?.modelType || "--",
        isCameraMoved: cameraMovedDto(video?.isCameraMoved),
        camera: formatDeviceCamera(video?.deviceCamera) || "--",
        deviceAngle: formatDeviceOrientation(video?.camera_orientation),
        trigger: triggerTypeObj[video?.trigger_type] || "-",
        iso: video?.iso || "-",
        shutter: Number(video?.shutter) || "-",
      }))
    : [];
}
export function transformHistoryDataToDataSourceTonal(historyData: any) {
  if (!historyData) {
    return [];
  }

  function formatVideoName(url: string): string {
    // Extract video name from URL
    const parts = url.split("/");
    const lastSegment = parts[parts.length - 1];
    return lastSegment;
  }

  const getEmail = (url: string, userEmail: any) => {
    if (userEmail) {
      return userEmail;
    }
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[0];
    // Get the last part of the URL

    // Return an object containing the email and video name

    return email.includes("@") ? email : "--";
  };

  function getDeviceType(deviceType: any) {
    if (deviceType?.toLowerCase() === "ios") {
      return deviceType.toUpperCase();
    }
    return deviceType;
  }

  function getDateTime(uploadedTime: any) {
    if (uploadedTime?.includes(".")) {
      return uploadedTime?.split(".")[0];
    }

    return uploadedTime;
  }

  function formatUserOrientation(orientation: any) {
    if (!orientation) {
      return "--";
    }
    if (orientation?.toLowerCase() === "faceon") {
      return "Face On";
    }

    return "Down The Line";
  }

  function formatMovementType(movementType: any) {
    if (!movementType) return "--";
    return movementType?.slice(0, 1).toUpperCase() + movementType?.slice(1);
  }

  function cameraMovedDto(isCameraMoved: any) {
    if (isCameraMoved === "true" || isCameraMoved === "True") {
      return "Yes";
    } else if (isCameraMoved === "false" || isCameraMoved === "False") {
      return "No";
    }

    return "-";
  }

  function formatDeviceOrientation(deviceOrientation: any) {
    if (!deviceOrientation) {
      return "--";
    }
    return (
      deviceOrientation?.slice(0, 1).toUpperCase() + deviceOrientation?.slice(1)
    );
  }

  function formatDeviceCamera(deviceCamera: any) {
    if (!deviceCamera) {
      return "--";
    }

    return deviceCamera.slice(0, 1).toUpperCase() + deviceCamera.slice(1);
  }

  return Array.isArray(historyData)
    ? historyData?.map((video: any, index: any) => ({
        queue_id: video.queue_id,
        fileId: video.filename,
        videoName: formatVideoName(video.queue_id) || `Video ${index + 1}`,
        handedness: handednessObj[video.handedness] || "--",
        uploader: getEmail(video?.queue_id, video?.email),
        sportName:
          video?.sportName?.slice(0, 1).toUpperCase() +
            video?.sportName?.slice(1) || "--",
        movementType: formatMovementType(video?.movementType) || "--",
        deviceType: getDeviceType(video?.deviceType) || "--",
        orientation: formatUserOrientation(video?.orientation) || "",
        dateTime: getDateTime(video.uploaded_at) || "",

        processingStatus:
          video?.current_status !== undefined
            ? video?.current_status
            : "--" || "--",
        totalProcessing: video?.processingTime || "--",
        userRole:
          video?.role?.slice(0, 1).toUpperCase() + video?.role?.slice(1) ||
          "--",
        modelType: video?.modelType || "--",
        isCameraMoved: cameraMovedDto(video?.isCameraMoved),
        camera: formatDeviceCamera(video?.deviceCamera) || "--",
        deviceAngle: formatDeviceOrientation(video?.deviceOrientation),
        trigger: triggerTypeObj[video?.trigger_type] || "-",
        iso: video?.iso || "-",
        shutter: Number(video?.shutter) || "-",
      }))
    : [];
}

export function transformHistoryDataToUserHistory(
  historyData: any,
  activeSportType: any
) {
  const { Items: items = [] } = historyData || {};

  function getDateTime(uploadedTime: any) {
    if (uploadedTime?.includes(".")) {
      return uploadedTime?.split(".")[0];
    }

    return uploadedTime;
  }

  const getEmailAndVideoNameFromUrl = (url: string) => {
    // Split the URL by '/'
    const parts = url.split("/");
    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[parts.length - 2];
    // Get the last part of the URL
    const lastPart = parts[parts.length - 1];
    // Remove the ".mp4" extension if it exists
    const videoName = lastPart?.replace(".mp4", "");
    // Return an object containing the email and video name

    return generateVideoName(email, videoName);
  };

  function formatVideoName(url: string): string {
    // Extract video name from URL
    const parts = url.split("/");
    const lastSegment = parts[parts.length - 1];
    return lastSegment;
  }

  const getEmail = (url: string, userEmail: any) => {
    if (userEmail) {
      return userEmail;
    }
    // Split the URL by '/'
    const parts = url.split("/");

    // Get the email address (assuming it's the second-to-last part of the URL)
    const email = parts[3];
    // Get the last part of the URL

    // Return an object containing the email and video name

    return email.includes("@") ? email : "--";
  };

  function formatDeviceOrientation(deviceOrientation: any) {
    if (!deviceOrientation) {
      return "--";
    }
    return (
      deviceOrientation?.slice(0, 1).toUpperCase() + deviceOrientation?.slice(1)
    );
  }

  function getDeviceType(deviceType: any) {
    if (deviceType?.toLowerCase() === "ios") {
      return deviceType.toUpperCase();
    }
    return deviceType;
  }

  function formatDeviceCamera(deviceCamera: any) {
    if (!deviceCamera) {
      return "--";
    }

    return deviceCamera.slice(0, 1).toUpperCase() + deviceCamera.slice(1);
  }

  function cameraMovedDto(isCameraMoved: any) {
    if (isCameraMoved === "true" || isCameraMoved === "True") {
      return "Yes";
    } else if (isCameraMoved === "false" || isCameraMoved === "False") {
      return "No";
    }

    return "-";
  }

  function formatUserOrientation(orientation: any) {
    if (!orientation) {
      return "--";
    }
    if (orientation?.toLowerCase() === "faceon") {
      return "Face On";
    }

    return "Down The Line";
  }

  const formatSwingType = (swingType: string): string => {
    // Capitalize the first letter of each word and handle specific cases
    const swingTypeExceptions: any = {
      "full swing": "Full Swing",
      "short game": "Short Game",
      putter: "Putter",
      bunker: "Bunker",
      scan: "Scan",
      // Add more exceptions here as needed
    };
    return (
      swingTypeExceptions[swingType.toLowerCase()] ||
      swingType?.replace(/\b\w/g, (c) => c.toUpperCase())
    );
  };

  return Array.isArray(items)
    ? items.map((video: any, index: number) => ({
        dateTime: getDateTime(video?.upload_time || video?.uploaded_at) || "",
        queue_id: video.queue_id,
        fileId: getEmailAndVideoNameFromUrl(video?.queue_id),
        videoName: formatVideoName(video.queue_id) || `Video ${index + 1}`,
        handedness: handednessObj[video.handedness] || "--",
        uploader: getEmail(video?.queue_id, video?.email),
        sportName:
          activeSportType?.slice(0, 1)?.toUpperCase() +
          activeSportType?.slice(1),
        deviceType:
          getDeviceType(video?.deviceType ?? video?.device_type) || "--",
        processingStatus:
          video?.current_status !== undefined
            ? video?.current_status
            : "--" || "--",
        totalProcessing: video?.total_processing || "--",
        orientation: formatUserOrientation(video?.orientation) || "",
        swingType: formatSwingType(video.swingType || "--"),
        userRole:
          video?.role?.slice(0, 1).toUpperCase() + video?.role?.slice(1) ||
          "--",

        videoRating: video?.videoRating,
        video_rating: video?.video_rating,

        modelType: video?.modelType || "--",
        isCameraMoved: cameraMovedDto(video?.isCameraMoved),
        camera: formatDeviceCamera(video?.camera_type) || "--",
        deviceAngle: formatDeviceOrientation(video?.camera_orientation),
        trigger: triggerTypeObj[video?.trigger_type] || "-",
        iso: video?.iso || "-",
        shutter: Number(video?.shutter) || "-",
        frameRate: Number(video?.frame_rate) || "-",
        exerciseType: video?.exerciseType || "--",
        movementType: video?.movementType || "--",
      }))
    : [];
}

export const transformTimelineDataToChartData = (timelineData: any): any => {
  if (timelineData.message) {
    return;
  }
  const summary = timelineData.summary;
  const {
    upload_time,
    wait_time,
    club,
    visualize_time,
    pose,
    processing_time,
  } = summary;

  const uploadTime = upload_time ? upload_time.timePassed : 0;
  const waitTime = wait_time ? wait_time.timePassed : 0;
  const processingTime = processing_time ? processing_time.timePassed : 0;
  const poseTime = pose ? pose.timePassed : 0;
  const clubTime = club ? club.timePassed : 0;
  const visualizeTime = visualize_time ? visualize_time.timePassed : 0;
  const hasVisualizeTime = visualizeTime !== 0; // Check if visualize time is not null or zero

  return [
    { name: "Upload Time", value: uploadTime },
    { name: "Wait Time", value: waitTime },
    { name: "Processing Time", value: processingTime },
    { name: "Visualize Time", value: visualizeTime },
    { name: "Pose", value: poseTime },
    { name: "Club", value: clubTime },
    { name: "Current Status", value: hasVisualizeTime ? true : false },
  ];
};

export const generateVideoName = (userEmail: string, videoName: string) => {
  return `${userEmail}/${videoName}`;
};
